import React, { useContext } from 'react';
import { AuthContext } from '../../context/auth-provider';
import { deskInPlan } from '../../utils/products';

// A test that mocks context/auth-provider with only `useAuth` leaves
// AuthContext undefined, and useContext(undefined) throws. Since IS2 the hook
// sits under ClockNote and the Stays screens, so it reads an empty context then
// — the answer is Desk, the wording as before.
const NO_AUTH = React.createContext<React.ContextType<typeof AuthContext> | undefined>(undefined);

/**
 * Does the signed-in person's organisation hold Lobbero Desk? (Independent
 * Stays IS1, utils/products.ts.) For WORDING inside Stays screens: a
 * Stays-only host is never told about a front desk they do not have.
 *
 * Reads the context directly rather than through useAuth(), which throws
 * outside an AuthProvider: the Stays components are rendered bare in their own
 * tests, and outside a provider the answer is Desk — the wording as before.
 */
export const useDeskInPlan = (): boolean =>
  deskInPlan(useContext((AuthContext || NO_AUTH) as React.Context<React.ContextType<typeof AuthContext> | undefined>)?.user);
